export default __webpack_public_path__ + "static/media/discount.e582026f.svg";